import { render, staticRenderFns } from "./passengerFlowList.vue?vue&type=template&id=57c1f238&scoped=true&"
import script from "./passengerFlowList.vue?vue&type=script&lang=js&"
export * from "./passengerFlowList.vue?vue&type=script&lang=js&"
import style0 from "./passengerFlowList.vue?vue&type=style&index=0&id=57c1f238&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c1f238",
  null
  
)

export default component.exports